<template>
        <div class="d-md-flex justify-center a" >
            <v-img src="../assets/main2.png" max-width="900" @load="flag = true"></v-img>
            <div class="logo">
                <img v-if="flag" class="logo2" src="../assets/logo2.png" @load="flag2 = true"/>
                <div class="d-flex justify-center">
                    <div v-if="flag && flag2" class="text-center text">60年のあゆみ</div>
                </div>
            </div>
            
        </div>
</template>

<script>
    export default {
        name: 'Title',
        data: function() {
            return {
                flag: false,
                flag2: false
            }
        }
    }
</script>

<style scoped>
    .a {
        position: relative;
        margin-bottom: 30px;
    }

    .logo {
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        margin:0;
        padding:0;
        white-space: nowrap;
    }
    
    .logo2 {
        position:relative;
        filter: drop-shadow(5px 5px 5px #666666);
        width: 50vw;
        max-width: 400px;
    }

    .a h1, h3{
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        margin:0;
        padding:0;
        white-space: nowrap;
        color: #98494C;
    }

    .text {
        font-size:30px; 
        font-weight:bold; 
        padding-top:10px;
        text-shadow:2px 2px 0 #FFF, -2px -2px 0 #FFF,
              -2px 2px 0 #FFF, 2px -2px 0 #FFF,
              0px 2px 0 #FFF,  0 -2px 0 #FFF,
              -2px 0 0 #FFF, 2px 0 0 #FFF;
        border-bottom: solid 3px #98494C;
        max-width:200px;
    }

    
</style>